import { PropsWithChildren } from 'react';
import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { Fallback, FallbackHeader, LinkGroup, LinkHeader, StyledLink } from './NoResults.styles';

const Suggestion = ({ url, children }: PropsWithChildren<{ url: string }>) => (
  <StyledLink trackingId={LinkId.NO_RESULTS_SUGGESTIONS} to={url}>
    {children}
  </StyledLink>
);

export const SeoFallback = () => (
  <Fallback>
    <FallbackHeader>This could also be of interest to you</FallbackHeader>
    <LinkGroup>
      <LinkHeader>Looking for a doctor?</LinkHeader>
      <Suggestion url="/appointments/gp/NSW/Sydney/Today/">Doctors in Sydney</Suggestion>
      <Suggestion url="/appointments/gp/VIC/Melbourne/Today/">Doctors in Melbourne</Suggestion>
      <Suggestion url="/appointments/gp/QLD/Brisbane/Today/">Doctors in Brisbane</Suggestion>
      <Suggestion url="/appointments/gp/WA/Perth/Today/">Doctors in Perth</Suggestion>
      <Suggestion url="/appointments/gp/SA/Adelaide/Today/">Doctors in Adelaide</Suggestion>
      <Suggestion url="/appointments/gp/TAS/Hobart/Today/">Doctors in Hobart</Suggestion>
      <Suggestion url="/appointments/gp/NT/Darwin/Today/">Doctors in Darwin</Suggestion>
      <Suggestion url="/appointments/gp/ACT/Canberra/Today/">Doctors in Canberra</Suggestion>
    </LinkGroup>
    <LinkGroup>
      <LinkHeader>Looking for bulk billing?</LinkHeader>
      <Suggestion url="/appointments/bulk-billing-gp/NSW/Sydney/Today/">
        Bulk billing in Sydney
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/VIC/Melbourne/Today/">
        Bulk billing in Melbourne
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/QLD/Brisbane/Today/">
        Bulk billing in Brisbane
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/WA/Perth/Today/">
        Bulk billing in Perth
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/SA/Adelaide/Today/">
        Bulk billing in Adelaide
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/TAS/Hobart/Today/">
        Bulk billing in Hobart
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/NT/Darwin/Today/">
        Bulk billing in Darwin
      </Suggestion>
      <Suggestion url="/appointments/bulk-billing-gp/ACT/Canberra/Today/">
        Bulk billing in Canberra
      </Suggestion>
    </LinkGroup>
    <LinkGroup>
      <LinkHeader>Looking for a dentist?</LinkHeader>
      <Suggestion url="/appointments/dentist/NSW/Sydney/Today/">Dentist in Sydney</Suggestion>
      <Suggestion url="/appointments/dentist/VIC/Melbourne/Today/">Dentist in Melbourne</Suggestion>
      <Suggestion url="/appointments/dentist/QLD/Brisbane/Today/">Dentist in Brisbane</Suggestion>
      <Suggestion url="/appointments/dentist/WA/Perth/Today/">Dentist in Perth</Suggestion>
      <Suggestion url="/appointments/dentist/SA/Adelaide/Today/">Dentist in Adelaide</Suggestion>
      <Suggestion url="/appointments/dentist/TAS/Hobart/Today/">Dentist in Hobart</Suggestion>
      <Suggestion url="/appointments/dentist/NT/Darwin/Today/">Dentist in Darwin</Suggestion>
      <Suggestion url="/appointments/dentist/ACT/Canberra/Today/">Dentist in Canberra</Suggestion>
    </LinkGroup>
    <LinkGroup>
      <LinkHeader>Looking for a physiotherapist?</LinkHeader>
      <Suggestion url="/appointments/physiotherapist/NSW/Sydney/Today/">
        Physiotherapist in Sydney
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/VIC/Melbourne/Today/">
        Physiotherapist in Melbourne
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/QLD/Brisbane/Today/">
        Physiotherapist in Brisbane
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/WA/Perth/Today/">
        Physiotherapist in Perth
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/SA/Adelaide/Today/">
        Physiotherapist in Adelaide
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/TAS/Hobart/Today/">
        Physiotherapist in Hobart
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/NT/Darwin/Today/">
        Physiotherapist in Darwin
      </Suggestion>
      <Suggestion url="/appointments/physiotherapist/ACT/Canberra/Today/">
        Physiotherapist in Canberra
      </Suggestion>
    </LinkGroup>
  </Fallback>
);
